import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faFilePdf, faImage, faCalendarAlt } from "@fortawesome/free-regular-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import NoCover from "../assets/img/nocover.png";

export const BookCard = React.forwardRef(({ book, onBookClick, onDelete }, ref) => {
  return (
    <div
      ref={ref}
      onClick={onBookClick}
      className="group bg-white rounded-2xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-lightGray cursor-pointer flex flex-row h-40 overflow-hidden"
    >
      {/* 🖼️ Image Section (Left Column - Fixed Width for Vertical Cover) */}
      <div className="relative w-32 shrink-0 overflow-hidden">
        <img
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          src={book.coverImage || NoCover}
          alt={book.title}
        />

        {/* Status badge (Top Left) */}
        <span
          className={`absolute top-2 left-2 text-white px-2 py-0.5 rounded text-[10px] font-medium uppercase tracking-wide z-10
            ${book.isPublished ? "bg-success" : "bg-gray"}`}
        >
          {book.isPublished ? "Published" : "Draft"}
        </span>
      </div>

      {/* 📝 Content Footer (Right Column) */}
      <div className="p-4 flex flex-col justify-between flex-grow min-w-0">
        <div>
          {/* Header: Content Type + Title */}
          <div className="flex justify-between items-start mb-2 gap-2">
            <h6 className="text-dark font-bold text-sm leading-tight line-clamp-2 flex-grow">
              {book.title}
              {book.createdAt && (
                <span className="block mt-1 text-[10px] text-gray font-medium font-sans">
                  <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                  {new Date(book.createdAt).toLocaleDateString('en-GB', {
                    day: 'numeric', month: 'short', year: 'numeric'
                  })}
                </span>
              )}
            </h6>

            <div
              className="flex items-center justify-center shrink-0 w-8 h-8 rounded-lg bg-light border border-lightGray"
            >
              {book.contentType === 'PDF' ? (
                <FontAwesomeIcon className="text-warning text-sm" icon={faFilePdf} />
              ) : book.contentType === "TextPages" ? (
                <FontAwesomeIcon className="text-warning text-sm" icon={faFile} />
              ) : (
                <FontAwesomeIcon className="text-warning text-sm" icon={faImage} />
              )}
            </div>
          </div>
        </div>

        {/* ⚙️ Action Footer */}
        <div className="flex justify-between items-end mt-2 pt-2 border-t border-lightGray">
          <div className="flex flex-col">
            <small className="text-gray text-[10px] uppercase tracking-wider font-semibold">Total Pages</small>
            <span className="font-bold text-dark text-sm">{book.totalPages || '0'}</span>
          </div>

          <button
            className="flex items-center gap-2 px-3 py-1.5 text-xs font-semibold text-danger bg-danger/10 rounded-lg hover:bg-danger hover:text-white transition-colors duration-200"
            onClick={(e) => {
              e.stopPropagation();
              onDelete && onDelete(book);
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
});
